/* eslint-disable react/no-unescaped-entities */
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo, { ldBreadcrumb } from "@/components/Seo";
import { CodeConformiteContent } from "@/content/legal/code-conformite.jsx";

export default function CodeConformite() {
  return (
    <div className="bg-[#FAFAF7] min-h-screen" data-testid="page-code-conformite">
      <Seo
        title="Code de Conformité CONFILEX — Référence officielle"
        description="Code de Conformité CONFILEX : cadre juridique, réglementaire, déontologique, technique et éthique. Compliance by design, respect des professions réglementées, IA responsable, protection des données, gouvernance."
        canonical="/code-conformite"
        keywords={[
          "code de conformité confilex",
          "compliance by design",
          "conformité juridique",
          "RGPD",
          "DSA",
          "AI Act",
          "professions réglementées",
          "déontologie plateforme numérique",
        ]}
        jsonLd={[
          ldBreadcrumb([
            { name: "Accueil", url: "/" },
            { name: "Code de Conformité", url: "/code-conformite" },
          ]),
        ]}
      />
      <Navbar variant="light" />
      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-12">
        <div className="text-xs uppercase tracking-[0.2em] text-[#C9A961] mb-3">
          Cadre contractuel · Référence officielle
        </div>
        <CodeConformiteContent />
      </main>
      <Footer />
    </div>
  );
}
